import { Tooltip } from "@mui/material";
import React from "react";
//icons

import { IoMdSave } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { AiFillEye } from "react-icons/ai";

export default function SurveyControls({ SaveClick, PreviewClick }) {
  return (
    <>
      {" "}
      <div className=" bg-white border-2 rounded-xl flex ">
        <Tooltip title="Anketi kaydetmenizi sağlar.">
          <button
            onClick={() => SaveClick()}
            className="btn btn-square m-2 hover:bg-green-700"
          >
            <IoMdSave size={32} />
          </button>
        </Tooltip>
      </div>
    </>
  );
}
